import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'

import List from './List'
import ListItem from './ListItem'
import Link from './Link'

import styles from './styles.scss'

import { connect } from 'react-redux'
import { compose } from 'recompose'
import { collapseSelector as nvqualCollapseSelector } from 'containers/Project/NvqualSection/selectors'

const mapStateToProps = state => {
  return {
    collapse: {
      nvqual_report: nvqualCollapseSelector(state)
    }
  }
}

class Index extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    containerId: PropTypes.string.isRequired,
  }

  renderNestedList (category) {
    const { containerId } = this.props
    const catLabel = category.label
    return(<List>
      {category.list.map(({ key, label }) => (
        <ListItem key={`${catLabel}${key}`}>
          <Link label={label} to={key} spy={false} containerId={containerId} />
        </ListItem>
      ))}
    </List>)
  }

  createCategoryScrollLinks() {
    const { categories, containerId, collapse } = this.props
    return categories.map(category => {
      var { key, label } = category
      return (
        <ListItem key={key}>
          <Link label={label}
            to={key}
            spy={true}
            containerId={containerId}
            offset={this.props.offset ? this.props.offset : 0}
          />
          {category.list && !collapse[key] && this.renderNestedList(category)}
        </ListItem>
      )
    })
  }

  render() {
    return (
      <Flex column className={styles.scrollNavigation}>
        <List>
          { this.createCategoryScrollLinks() }
        </List>
      </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, null)
const withStyle = CSSModules(styles)
export default compose(
  withConnect,
  withStyle
)(Index)
